<div class="w-100 h-100">
  @if (isLoading) {
    <ngx-skeleton-loader
      count="1"
      [theme]="{ height: 'calc(100% - 6px)', width: '100%' }"
    />
  }
  @else {
    <pdf-viewer
      [src]="pdfSrc"
      [render-text]="true"
      [show-borders]="false"
      [original-size]="false"
      [autoresize]="true"
      [stick-to-page]="true"
      (after-load-complete)="onPdfLoaded()"
      style="width: 100%; height: 98%">
    </pdf-viewer>
  }

</div>